import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { getGroupDetail } from '../../services/api';

const GroupDetail = () => {
  const { id } = useParams();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGroup();
  }, [id]);

  const loadGroup = async () => {
    try {
      const response = await getGroupDetail(id);
      if (response.success) {
        setGroup(response.data);
      }
    } catch (error) {
      console.error('Error loading group:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Group Details
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Group ID: {id}
        </Typography>
        {group && (
          <>
            <Typography variant="h6" sx={{ mt: 2 }}>{group.group_name || group.group_name_native}</Typography>
            <Typography variant="body2" color="text.secondary">
              Country: {group.country_name || 'N/A'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: {group.group_email || 'N/A'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Status: {group.group_status === 1 ? 'Active' : 'Inactive'}
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default GroupDetail;